import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type RegisterUserMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
  password: Types.Scalars['String']['input'];
}>;


export type RegisterUserMutation = { __typename: 'Mutation', registerUser: { __typename: 'RegisterUserResult', userUuid: string, email: string, verificationRequired: boolean } };

export type ResendVerificationEmailMutationVariables = Types.Exact<{
  email: Types.Scalars['String']['input'];
}>;


export type ResendVerificationEmailMutation = { __typename: 'Mutation', resendVerificationEmail: boolean };

export const RegisterUserDocument = gql`
    mutation registerUser($email: String!, $password: String!) {
  registerUser(email: $email, password: $password) {
    userUuid
    email
    verificationRequired
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterUserGQL extends Apollo.Mutation<RegisterUserMutation, RegisterUserMutationVariables> {
    override document = RegisterUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendVerificationEmailDocument = gql`
    mutation resendVerificationEmail($email: String!) {
  resendVerificationEmail(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendVerificationEmailGQL extends Apollo.Mutation<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables> {
    override document = ResendVerificationEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }